import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/stores/auth';
import { callRecordLegalConsent } from '@/lib/callables';
import { isLegalConsentCurrent, LEGAL_VERSIONS } from '@makhe/shared';
import { toast } from '@/components/ui/Toast';

export function LegalConsentGate() {
  const { firebaseUser, userDoc } = useAuth();
  const [busy, setBusy] = useState(false);
  const [accepted, setAccepted] = useState(false);

  if (!firebaseUser || !userDoc) return null;
  if (isLegalConsentCurrent(userDoc.legalConsent)) return null;

  const accept = async () => {
    if (!accepted) {
      toast.error('Please accept the Terms and Privacy Policy.');
      return;
    }
    setBusy(true);
    try {
      await callRecordLegalConsent({
        termsVersion: LEGAL_VERSIONS.terms,
        privacyVersion: LEGAL_VERSIONS.privacy,
      });
      toast.success('Thanks — you’re all set.');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Could not save consent.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open title="Updated terms" onClose={() => {}}>
      <p className="text-sm text-makhe-muted">
        Please review and accept our Terms of Service and Privacy Policy to continue using Makhe.
      </p>
      <label className="mt-4 flex items-start gap-2 text-sm">
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
          className="mt-0.5"
        />
        <span>
          I agree to the{' '}
          <Link to="/legal/terms" className="underline" target="_blank">
            Terms
          </Link>{' '}
          and{' '}
          <Link to="/legal/privacy" className="underline" target="_blank">
            Privacy Policy
          </Link>
          .
        </span>
      </label>
      <Button className="mt-6 w-full" loading={busy} onClick={accept}>
        Continue
      </Button>
    </Modal>
  );
}
